export const schoolSubjectKeys = {
  all: ['schoolSubjects'],

  details: () => [...schoolSubjectKeys.all, 'detail'],
  detail: (id?: number) => [...schoolSubjectKeys.details(), id ?? null],

  lists: () => [...schoolSubjectKeys.all, 'list'],

  providerList: (params: {
    page: number;
    pageSize: number;
    search: string;
    onlyWithoutTypes: boolean;
    onlyNotClassifiable: boolean;
    schoolLevel: number | null;
    schoolTypeId: number | null;
  }) => [
    ...schoolSubjectKeys.lists(),
    'provider',
    params.page,
    params.pageSize,
    params.search,
    params.onlyWithoutTypes,
    params.onlyNotClassifiable,
    params.schoolLevel,
    params.schoolTypeId,
  ],

  tenantTemplates: (tenantId?: number) => [...schoolSubjectKeys.lists(), 'tenant', tenantId ?? null],

  providerTemplates: (templateSetId?: number, schoolLevel?: number) => [
    ...schoolSubjectKeys.lists(),
    'provider-templates',
    templateSetId ?? null,
    schoolLevel ?? null,
  ],

  classList: (classId?: number) => [...schoolSubjectKeys.lists(), 'class', classId ?? null],

  byTemplateSet: (templateSetId: number | null, schoolLevel: number | null) => [
    ...schoolSubjectKeys.all,
    'templates',
    'byTemplateSet',
    templateSetId,
    schoolLevel,
  ],

  canAccessAll: (classId?: number) => [...schoolSubjectKeys.all, 'canAccessAll', classId ?? null],

  templateList: (params: {
    canManageCompetences?: boolean;
    hasProviderAccess?: boolean;
    templateSetId?: number | null;
  }) => [
    ...schoolSubjectKeys.lists(),
    'template',
    params.canManageCompetences ?? null,
    params.hasProviderAccess ?? null,
    params.templateSetId ?? null,
  ],
};
